import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel';
import AOS from 'aos';
import 'aos/dist/aos.css';

import "./browser";
import "./menu";
import "./menu-active";
import "./elements-cour";
import "./video";
import "./carousel";
import "./alert";
import "./accesrapide";
//import "./accordeon";
import "./tab";
import "./accordeon-tab-anchor";
import "./table-wrap";
import "./sticky-cards";
import "./recherche";
import "./recherche-exec";
import "./pan";
import "./partials-header-default";
import "./elements-tab-nav";
import "./modal";


$(document).ready(function(){
	AOS.init();
});

